import { shareAction } from '../actions/share'
import { shareMutation } from '../mutations/share'

export const share = {
  state: {
    status: false
  },
  mutations: shareMutation,
  actions: shareAction
}



// WEBPACK FOOTER //
// ./src/store/modules/share.js